import React, { useEffect, useState } from "react";
import { DKLabel, DKSpinner, DKButton, DKInput, DKTooltipWrapper, DKIcon, DKRadioButton, DKIcons, showLoader, removeLoader, showToast, TOAST_TYPE, showAlert } from "deskera-ui-library";
import { INPUT_TYPE } from "../../constants/Constant";
import { APPLY_COMP_OFF_FIELDS, STATUS_COMP_OFF } from "./CompOffConstants";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";
import ic_erro_info from "../../assets/icons/ic_info_error.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers, selectUsers } from "../../Redux/Slices/PayrollSlice";
import Utility, { deepClone } from "../../utility/Utility";
import EmployeeListService from "../../services/EmployeeListService";
import { CompoffService } from "../../services/CompOffService";
import FileUpload from "../common/FileUpload";
import AttachmentService, { Entity } from "../../services/AttachmentService";
import { saveAs } from 'file-saver';
import { getFileName } from "../configs/config";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import moment from "moment";
import i18next from "i18next";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const ApplyCompOff = (props) => {

    /**Hooks */
    const [isEdit, setEditFlag] = useState(props.isEdit);
    const [dataToUpdate, setDataToUpdate] = useState(props.data);
    const [isProcessing, setIsProcessing] = useState(true);
    const [formFieldConfig, setFormFieldConfig] = useState(APPLY_COMP_OFF_FIELDS);
    const [formValues, setFormValues] = useState({
        duration: "fullDay"
    });
    const [compOffList, setCompOffList] = useState([]);
    const [attachmentPopup, setAttachmentPopup] = useState({
        showPopup: false,
        fileList: []
    })
    const [canValidate, setCanValidate] = useState(false)
    const [isAllowForFullDay, setAllowForFullDay] = useState(true);
    const [isAttachmentMandatory, setIsAttachmentMandatory] = useState(false);

    /**Selectors */
    const userList = useSelector(selectUsers);
    /**Dispatch */
    const dispatch = useDispatch();

    const isAdmin = TenantService.get(TENANT.IS_ADMIN);
    const isManager = TenantService.get(TENANT.IS_MANAGER);

    useEffect(() => {
        if(isAdmin || isManager) {
            loadUsersList();
        }
    }, [])
    useEffect(() => {
        setIsProcessing(true);
        let config = updateFormFieldConfigOptions();
        if (isEdit) {
            updateFormConfigForEdit(config);
            updateFormValues(config);
        }
        config = setUserFieldValue(null, config);
        setFormFieldConfig(config);
        setIsProcessing(false);


    }, [userList]);
    const updateFormConfigForEdit = (columnConfig) => {
        const config = columnConfig;
        const alteredConfig = [];
        config.forEach((c) => {
            switch (c.columnCode) {
                case 'attachments':
                default:
                    break;
            }
        });
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});

    };
    const setUserFieldValue = (userId, config) => {
        const employeeColumnConfig = config.find(col => col.columnCode == 'employees')
        if (Utility.isEmpty(userId)) {
            userId = TenantService.get(TENANT.USER_ID);
        }
        formValues['employees'] = employeeColumnConfig?.options?.find(u => u.id == userId);
        if (formValues['employees']?.iamUserId) {
            getCompOffByUserId(formValues['employees'].iamUserId, config);
            config = leaveDateBetweenDOJAndTermination(formValues,config)
            config = config.config
        }
        if (!isEdit) {
            setFormValues({
                ...formValues
            })
        }
        return config
    }

    const leaveDateBetweenDOJAndTermination = (formData, config) => {
        let alteredFields = [];
        let isInvalid = false;
        if (!Utility.isEmpty(formData['leaveDate'])) {
            if (!Utility.isEmpty(formData['employees']?.dateOfJoining)) {
                const isBeforeJoiningDate = moment(formData['leaveDate'], 'YYYY-MM-DD').isBefore(moment(formData['employees']?.dateOfJoining),'days');
                if (isBeforeJoiningDate) {
                    isInvalid = true;
                    alteredFields.push({ columnCode: "leaveDate", errMsg: "Leave date should not before Date of Joining of selected employee.", isValid: false, canValid: true })
                } else {
                    isInvalid = false;
                    alteredFields.push({ columnCode: "leaveDate", errMsg: "", isValid: true, canValid: true })
                }
            }
            if (!Utility.isEmpty(formData['employees']?.dateOfTermination)) {
                const isAfterDateOfTermination = moment(formData['leaveDate'], 'YYYY-MM-DD').isAfter(moment(formData['employees']?.dateOfTermination),'days');
                if (isAfterDateOfTermination) {
                    isInvalid = true;
                    alteredFields.push({ columnCode: "leaveDate", errMsg: "Leave date should not after Date of Termination of selected employee.", isValid: false, canValid: true })
                } else {
                    isInvalid = false;
                    alteredFields.push({ columnCode: "leaveDate", errMsg: "", isValid: true, canValid: true })
                }
            }
            alteredFields.push({columnCode:"attachments", required: formData.isAttachmentMandatory })
            EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
        }
        return {config:config,isInvalid:isInvalid};
    }

    const loadUsersList = async () => {
        try {
            setIsProcessing(true);
            await dispatch(fetchUsers())
        } catch (err) {

        }
    }
    const loadEmployeeCompOffsForCondition = (condition,config,leaveDate) => {
        setIsProcessing(true);
        let totalUsedBalanceForSelectedDate = 0;
        CompoffService.getEmployeeCompOffsForCondition({
            page: 1,
            limit: 20,
            condition: condition,
            userId: [parseInt(formValues?.employees?.iamUserId)]

        }).then(res => {
            
            const ind = config.findIndex(c => c.columnCode == 'leaveDate');
            if (ind != -1) {
                let existingCompOffData = [] 
                if(res && res.data && res.data.length != 0) {
                    existingCompOffData = res.data.filter(compData=>compData.status != STATUS_COMP_OFF.REJECTED);
                }
                if (existingCompOffData.length != 0) {
                    existingCompOffData.forEach(d => {
                        totalUsedBalanceForSelectedDate += (d.approvedDays + d.appliedDays);
                    })
                    if (totalUsedBalanceForSelectedDate >= 1) {
                        config[ind].isValid = false;
                        config[ind].errMsg = "Comp-off for selected date is already applied.";
                        config[ind].canValid = true;
                    } else if (totalUsedBalanceForSelectedDate == 0.5) {
                        config[ind].isValid = true;
                        config[ind].canValid = true;
                        let index = config.findIndex(f => f.columnCode == 'duration');
                        if (index != -1) {
                            config = updateRadioButtonValidation(formValues.duration, config, index, false);
                        }
                        setAllowForFullDay(false);
                    } else {
                        config[ind].isValid = true;
                        config[ind].canValid = true;
                        let index = config.findIndex(f => f.columnCode == 'duration');
                        if (index != -1) {
                            config = updateRadioButtonValidation(formValues.duration, config, index, true);
                        }
                        setAllowForFullDay(true);
                    }
                } else {
                    // No compoff applied for selected date
                    // so now check for available balance in selected comp off
                    if (formValues.compOff) {
                        const totalUsedCompOffBalance = formValues.compOff.approvedDays + formValues.compOff.appliedDays;
                        if (formValues.balanceDays < totalUsedCompOffBalance) {
                            config[ind].isValid = false;
                            config[ind].errMsg = "Comp-off for selected date is already applied.";
                            config[ind].canValid = true;

                            let index = config.findIndex(f => f.columnCode == 'duration');
                            if (index != -1) {
                                config = updateRadioButtonValidation(formValues.duration, config, index, false);
                            }
                            setAllowForFullDay(false);
                        } else if (formValues.balanceDays >= totalUsedCompOffBalance) {
                            const totalRemainingBalance = formValues.balanceDays - totalUsedCompOffBalance;
                            config[ind].isValid = true;
                            config[ind].errMsg = "";
                            config[ind].canValid = true;
                            if(totalRemainingBalance == 0.5) {
                                setFormValues({
                                    ...formValues,
                                    duration:'halfDay'
                                })
                                setAllowForFullDay(false);
                            } else {
                                let index = config.findIndex(f => f.columnCode == 'duration');
                                if (index != -1) {
                                    config = updateRadioButtonValidation(formValues.duration, config, index, true);
                                }
                                setAllowForFullDay(true);
                            }
                        }
                    }
                }
            }

        }).finally(() => {
            if(totalUsedBalanceForSelectedDate < 1) {
                getLeaveDetails(config,leaveDate,totalUsedBalanceForSelectedDate);
            } else {
                setFormFieldConfig(config);
                setIsProcessing(false)
            }
        })
    }
    const getLeaveDetails = (config,leaveDate,totalUsedBalanceForSelectedDate) => {
        let alteredFields = [];
        if(parseFloat(formValues.employees?.iamUserId)) {
            const param = {
                module: 'applications',
                fromDate: moment(leaveDate).format('YYYY-MM-DD'),
                toDate: moment(leaveDate).format('YYYY-MM-DD'),
                id: '',
                iamUserId: formValues.employees?.iamUserId
            }
            CompoffService.getLeaveDetail(param).then(res=>{
                let leaveData = res?.data ? res.data.filter(l=>l.status != 'rejected') :[]
                if(leaveData && leaveData.length != 0) {
                    let totalDurationOfLeaveApplied = 0;
                    leaveData.forEach(l=>{
                        l.leaveDates.map(ld=>{
                            if(ld.leaveDate == param.fromDate) {
                                totalDurationOfLeaveApplied += (ld.isHalfDate) ? 0.5 : 1
                            }
                        })
                    })
                    if( totalDurationOfLeaveApplied > 1) {
                        let isAllowForHalfDay = false;
                        leaveData.forEach(leave=>{
                            const filterLeavesForHalfday = leave.leaveDates.find(ld=>(ld.leaveDate == param.fromDate && ld.isHalfDate));
                            if(filterLeavesForHalfday) {
                                isAllowForHalfDay = !isAllowForHalfDay;
                            }
                            
                        })
                        if(isAllowForHalfDay && totalUsedBalanceForSelectedDate<0.5) {
                            alteredFields.push({ columnCode: "leaveDate", errMsg: "", hasError: false, isValid: true, canValid: true });
                            let index = config.findIndex(f => f.columnCode == 'duration');
                            if (index != -1) {
                                config = updateRadioButtonValidation(formValues.duration, config, index, false);
                            }
                            setFormValues({
                                ...formValues,
                                duration:'halfDay'
                            })
                            setAllowForFullDay(false);
                        } else {
                            alteredFields.push({ columnCode: "leaveDate",errMsg:i18next.t("LEAVE_EXIST"), hasError:true, isValid:false,canValid:true });
                        }
                        
                        
                    } else if((totalUsedBalanceForSelectedDate+totalDurationOfLeaveApplied) >= 1) {
                        alteredFields.push({ columnCode: "leaveDate",errMsg:i18next.t("LEAVE_EXIST"), hasError:true, isValid:false,canValid:true });
                    } else if (totalUsedBalanceForSelectedDate <= 0.5 && totalDurationOfLeaveApplied == 0.5) {
                        alteredFields.push({ columnCode: "leaveDate", errMsg: "", hasError: false, isValid: true, canValid: true });
                        let index = config.findIndex(f => f.columnCode == 'duration');
                        if (index != -1) {
                            config = updateRadioButtonValidation(formValues.duration, config, index, false);
                        }
                        setFormValues({
                            ...formValues,
                            duration:'halfDay'
                        })
                        setAllowForFullDay(false);
                    } else if(totalUsedBalanceForSelectedDate == 0 && totalDurationOfLeaveApplied == 1) {
                        alteredFields.push({ columnCode: "leaveDate", errMsg: i18next.t("LEAVE_EXIST"), hasError: true, isValid: false, canValid: true });
                        let index = config.findIndex(f => f.columnCode == 'duration');
                        if (index != -1) {
                            config = updateRadioButtonValidation(formValues.duration, config, index, true);
                        }
                        setAllowForFullDay(true);
                    }
                    config = EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
                    
                }
            }).finally(()=>{
                setFormFieldConfig(config);
                setIsProcessing(false)
            })
        }
        
    }
    const getCompOffByUserId = (id, configs, alterFields=[]) => {
        setIsProcessing(true);
        showLoader("Fetching user's comp off detail... Please wait")
        CompoffService.getCompOffByUserId(id).then(res => {
            if (res) {
                let selectedCompOff = null;
                let compList = res.map(c => {
                    if (isEdit && dataToUpdate['compOffId'] == c.compOffId) {
                        selectedCompOff = c;
                        selectedCompOff['name'] = c.compOffDate;
                    }
                    return {
                        id: c.compOffId,
                        name: c.compOffDate,
                        ...c
                    }
                })
                compList = compList.filter(c=>c.balanceDays!=0)
                if(selectedCompOff?.isAttachmentMandatory) {
                    alterFields.push({columnCode:"attachments", required: selectedCompOff.isAttachmentMandatory })
                }
                let config = updateCompOffConfigOptions(compList, configs, alterFields);
                setFormFieldConfig(config);
                setCompOffList(compList);
                if (isEdit) {
                    let fulldayAllow = getBalanceLeaveFullDayAllow(selectedCompOff);
                    if(isEdit && dataToUpdate && selectedCompOff?.compOffId == dataToUpdate['compOffId']) {
                        fulldayAllow = (selectedCompOff.totalDaysAvailable - selectedCompOff.approvedDays) >= 1 ? true:false;
                    }
                    setAllowForFullDay(fulldayAllow);
                    setFormValues({
                        ...formValues,
                        compOff: selectedCompOff
                    })
                }

            }
        }, error => {

        }).finally(() => {
            setIsProcessing(false);
            removeLoader()
        })
    }
    const compOffBetweenDOJAndTermination = (formData, config,alteredFields) => {
        
        let isInvalid = false;
        if (!Utility.isEmpty(formData['compOffDate'])) {
            if (!Utility.isEmpty(formData['employees']?.dateOfJoining)) {
                const isBeforeJoiningDate = moment(formData['compOffDate'], 'YYYY-MM-DD').isBefore(moment(formData['employees']?.dateOfJoining),'days');
                if (isBeforeJoiningDate) {
                    isInvalid = true;
                    alteredFields.push({ columnCode: "compOff", errMsg: "Comp date should not before Date of Joining of selected employee.", isValid: false, canValid: true })
                } else {
                    isInvalid = false;
                    alteredFields.push({ columnCode: "compOff", errMsg: "", isValid: true, canValid: true })
                }
            }
            if (!Utility.isEmpty(formData['employees']?.dateOfTermination)) {
                const isAfterDateOfTermination = moment(formData['compOffDate'], 'YYYY-MM-DD').isAfter(moment(formData['employees']?.dateOfTermination),'days');
                if (isAfterDateOfTermination) {
                    isInvalid = true;
                    alteredFields.push({ columnCode: "compOff", errMsg: "Comp-off date should not after Date of Termination of selected employee.", isValid: false, canValid: true })
                } else {
                    isInvalid = false;
                    alteredFields.push({ columnCode: "compOff", errMsg: "", isValid: true, canValid: true })
                }
            }
            EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
        }
        return {config:config,isInvalid:isInvalid};
    }
    const prePareForSubmit = () => {
        let data = {
            ...formValues,
            iamUserId: parseFloat(formValues.employees?.iamUserId),
            compOffId: formValues.compOff?.compOffId,
            compOffTillDate: formValues.compOff?.compOffTillDate,
            fromFullDay: formValues.duration === 'halfDay' ? false : true,
            toFullDay: formValues.duration === 'halfDay' ? false : true,
            duration: formValues.duration === 'halfDay' ? 0.5 : 1,
            description: formValues.description,
            status: STATUS_COMP_OFF.PENDING,
            from: formValues.leaveDate ? moment(formValues.leaveDate).format('YYYY-MM-DD') : "",
            to: formValues.leaveDate ? moment(formValues.leaveDate).format('YYYY-MM-DD') : ""
        }

        if (formValues.compOff?.compOffId) {
            data = {
                ...formValues.compOff,
                ...data,
                attachments: formValues.attachments
            }
        }
        if (isEdit) {
            data['id'] = dataToUpdate['id'];
            data['appliedDays'] = data['duration']
        } else {
            data['appliedDays'] = data['duration'] + data['appliedDays'];
            data['balanceDays'] = data['totalDaysAvailable'] - data['approvedDays'];
        }
        return data;
    }
    const isValidForm = () => {
        let isValid = true;
        formFieldConfig.forEach(f => {
            if (f.required && ((Utility.isEmpty(formValues[f.columnCode]) && formValues[f.columnCode] !== 0) || !f['isValid'])) {
                isValid = false;
            }
        })
        return isValid
    }
    const onSave = () => {
        setCanValidate(true);
        if (isProcessing) {
            return
        }
        setTimeout(() => {
            if (!isValidForm()) {
                return;
            }
            const data = prePareForSubmit();
            setIsProcessing(true)
            CompoffService.applyCompOff(data, isEdit).then(res => {
                if (isEdit) {
                    showToast("Comp-off updated successfully", TOAST_TYPE.SUCCESS);
                } else {
                    showToast("Comp-off applied successfully", TOAST_TYPE.SUCCESS);
                }
                props.onClose(true)
            }, error => {
                if (error && error.message) {
                    showToast(error.message, TOAST_TYPE.FAILURE);
                } else if(typeof error == 'string' && error.trim() == 'insufficient comp off balance') {
                    showToast('Insufficient comp off balance available for selected employee.', TOAST_TYPE.FAILURE);
                    
                } else if(typeof error == 'string' && error.trim() == 'already this day has covered') {
                    showToast('Selected day already has been covered.', TOAST_TYPE.FAILURE);
                    
                } else {
                    showToast('Something went wrong', TOAST_TYPE.FAILURE);
                }
            }).finally(() => {
                setIsProcessing(false)
            })
        }, 100);
    }

    const uploadDocument = (files) => {
        if (files && files[0]) {
            showLoader("Uploading files... Please wait");
            AttachmentService.getUploadFileURL(
                files[files.length - 1].fileContent,
                Entity.PEOPLE_DOCUMENT
            ).then(
                (response) => {
                    if (response?.relativePath) {
                        formValues['attachments'] = [response.relativePath];
                        setFormValues({
                            ...formValues
                        })
                        setAttachmentPopup({
                            showPopup: false
                        })
                    }
                    showToast("The document is uploaded successfully.", TOAST_TYPE.SUCCESS);
                },
                (error) => {
                    if (error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
                        showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
                    } else {
                        showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE);
                    }
                }
            ).finally(() => {
                removeLoader();
            });
        }
    }
    const downloadDocument = (path) => {
        showLoader("Downloading document... Please wait");
        AttachmentService.getPresignedURL(path).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        saveAs(response, getFileName(path));
                    },
                    (error) => {
                        removeLoader();
                    }
                );
            },
            (error) => {
                removeLoader();
                showToast("Something went wrong", TOAST_TYPE.FAILURE);
            }
        );
    }

    const resetUploadConfig = () => {
        setAttachmentPopup({
            showPopup: false
        })
    }
    const showUploadPopup = () => {
        return (
            <FileUpload
                isMultiSelect={false}
                onSave={(files) => {
                    uploadDocument(files);
                }}
                onClose={() => {
                    resetUploadConfig();
                }}
            />
        );
    }
    const getBalanceLeaveFullDayAllow = (leaveObj) =>{
        return (leaveObj?.balanceDays - leaveObj?.appliedDays) >= 1 ? true : false
    }
    const getHeader = () => {
        return (
            <div className="row justify-content-between p-h-m">
                <div className="row">
                    <DKLabel
                        text={`${!props.isEdit ? "Apply Comp Off" : "Edit Applied Comp Off"}`}
                        className="fw-b fs-m"
                    />
                    {isProcessing && <DKSpinner className="pl-s" />}
                </div>
                <div className="row width-auto">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={() => {
                            props.onClose(false);
                        }}
                    />
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-r"
                        onClick={() => {
                            onSave();
                        }}
                    />
                </div>
            </div>
        );
    };
    const onChange = (value, columnConfigObj) => {
        let formVal = formValues;
        let config = deepClone(formFieldConfig);
        let alteredFields = [];
        switch (columnConfigObj.columnCode) {
            case 'employees':
                formVal['leaveDate'] = "";
                formVal['compOff'] = "";
                alteredFields = [{ columnCode: "leaveDate",errMsg:"", hasError:false, isValid:true,canValid:true }]
                    config = EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
                    getCompOffByUserId(value.iamUserId,config, alteredFields);
                break;
            case 'leaveDate':
                const selectedWeekDay = moment(value).format('dddd');
                const workingDays = TenantService.get(TENANT.TENANT_WORK_WEEK);
                let isApplyOnWeekEnds = false;
                if(workingDays && workingDays.length !=0) {
                    const workWeekDay = workingDays.find(w=>w.day == selectedWeekDay?.toLowerCase());
                    if (workWeekDay && !workWeekDay.isWorkingDay) {
                        alteredFields = [{ columnCode: "leaveDate", errMsg: "Comp off should not be allowed to apply on Weekly off days", isValid: false, canValid: true }]
                        EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
                        setFormFieldConfig(config)
                        isApplyOnWeekEnds = true;
                    }
                }
                if (!isApplyOnWeekEnds) {
                    const newConfig = leaveDateBetweenDOJAndTermination({ ...formVal, leaveDate: moment(value).format('YYYY-MM-DD') }, config);
                    config = newConfig.config
                    if (isEdit && moment(value).format('YYYY-MM-DD') === dataToUpdate['from']) {
                        alteredFields = [{ columnCode: "leaveDate", errMsg: "", isValid: true, canValid: true }]
                        EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
                        setFormFieldConfig(config)
                    } else if (newConfig.isInvalid) {
                        setFormFieldConfig(config);
                    } else {
                        loadEmployeeCompOffsForCondition([
                            {
                                colId: "from",
                                opr: "eq",
                                key: "from",
                                value: moment(value).format('YYYY-MM-DD'),
                                type: ""
                            }
                        ], config, value)
                    }
                }
                
                break;
            case 'compOff':
                formVal = {
                    ...formVal,
                    ...value,
                    duration: (formVal['fromFullDay'] || formVal['toFullDay']) ? 'fullDay' : 'halfDay',
                    leaveDate:""
                }
                let index = config.findIndex(f => f.columnCode == 'duration');
                const tooltiptext = i18next.t("APPLIED_COMPOFF_NOT_ALLOW_FULL_DAY");
                const newConfig = compOffBetweenDOJAndTermination({ ...formVal }, config,alteredFields);
                config = newConfig.config
                if(newConfig.isInvalid) {
                    setFormFieldConfig(config)
                    return
                }
                if(value.totalDaysAvailable > value.appliedDays && !isEdit && (value.totalDaysAvailable > value.approvedDays) && (value.totalDaysAvailable != (value.appliedDays + value.approvedDays))) {
                    alteredFields.push({ columnCode: "compOff",hasError:false, isValid:true,canValid:true });
                    const fulldayAllow = getBalanceLeaveFullDayAllow(value);
                    
                    if (index != -1) {
                        let isValid;
                        
                        if (formVal.duration == 'fullDay') {
                            isValid = (fulldayAllow !== undefined) ? fulldayAllow : isAllowForFullDay;
                        } else {
                            isValid = true;
                        }
                        alteredFields.push({ columnCode: "duration",hasError:false, isValid:isValid,canValid:true,tooltiptext:tooltiptext });
                    }
                    setAllowForFullDay(fulldayAllow);
                } else if(isEdit && value.compOffId == dataToUpdate['compOffId']) {
                    alteredFields.push({ columnCode: "compOff", hasError: false, isValid: true, canValid: true, errMsg: "" })
                    formVal['duration'] = dataToUpdate['duration']==0.5 ? 'halfDay': 'fullDay';
                    if (value.totalDaysAvailable >= 1) {
                        alteredFields.push({ columnCode: "duration", isValid: true, canValid: true, tooltiptext: tooltiptext });
                        setAllowForFullDay(true);
                    } else {
                        alteredFields.push({ columnCode: "duration", isValid: dataToUpdate['duration']==0.5, canValid: true, tooltiptext: tooltiptext });
                        setAllowForFullDay(false);
                    }
                } else if(isEdit && value.compOffId != dataToUpdate['compOffId']  && value.totalDaysAvailable > value.appliedDays && (value.totalDaysAvailable > value.approvedDays) && (value.totalDaysAvailable != (value.appliedDays + value.approvedDays))) {
                    alteredFields.push({ columnCode: "compOff",hasError:false, isValid:true,canValid:true });
                    const fulldayAllow = getBalanceLeaveFullDayAllow(value);
                    
                    if (index != -1) {
                        let isValid;
                        
                        if (formVal.duration == 'fullDay') {
                            isValid = (fulldayAllow !== undefined) ? fulldayAllow : isAllowForFullDay;
                        } else {
                            isValid = true;
                        }
                        alteredFields.push({ columnCode: "duration",hasError:false, isValid:isValid,canValid:true,tooltiptext:tooltiptext });
                    }
                    setAllowForFullDay(fulldayAllow);
                } else if(value.totalDaysAvailable == value.approvedDays && value.balanceDays == 0) {
                    alteredFields = [{ columnCode: "compOff",hasError:true, isValid:false,canValid:true,errMsg:i18next.t("USED_COMP_OFF") }]
                } else {
                    alteredFields = [{ columnCode: "compOff",hasError:true, isValid:false,canValid:true,errMsg:"Comp-off was already applied for selected employee" }]
                    
                }
                alteredFields.push({columnCode:"attachments", required:value.isAttachmentMandatory })
                EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
                setFormFieldConfig(config)

                break;
        }
        formVal[columnConfigObj.columnCode] = value;
        setFormValues({
            ...formVal
        })

    }
    const getFieldRequired = (field) => {
        const validator = field.validation;
        let isRequired = false;
        if (validator && validator.some(x => x === "required")) isRequired = true;
        return isRequired;
    }
    const getRadioButtons = (c, index) => {
        return c.radioButtons.map(r => {
            return (
                <div className="row" style={{ width: "auto" }}>
                    <DKRadioButton
                        isSelected={r.fieldId === formValues[c.columnCode]}
                        color="bg-app"
                        onClick={() => {
                            let columnConfig = deepClone(formFieldConfig);
                            if (!c.readOnly) {
                                formValues[c.columnCode] = r.fieldId;
                            }
                            columnConfig = updateRadioButtonValidation(formValues[c.columnCode], columnConfig, index);
                            setFormFieldConfig(columnConfig);
                        }}
                    />
                    <DKLabel className="ml-s mr-l" text={r.fieldLabel} />
                </div>
            )
        })
    }
    const updateRadioButtonValidation = (value, columnConfig, index, fulldayAllow) => {
        if (value == 'fullDay') {
            columnConfig[index].isValid = (fulldayAllow !== undefined) ? fulldayAllow : isAllowForFullDay;
            columnConfig[index].tooltiptext = i18next.t("APPLIED_COMPOFF_NOT_ALLOW_FULL_DAY")

        } else {
            columnConfig[index].isValid = true;
        }
        return columnConfig
    }
    const deleteAttachment = (index) => {
        let attachments = deepClone(formValues['attachments'])

        attachments.splice(index, 1);
        setFormValues({
            ...formValues,
            attachments : attachments
        })
    }
    const attachmentField = (c) => {
        return (
            <div className={`column p-h-m mb-l padding-bottom-mobile ${c.columnCode}`}>
                <div className="row row-responsive justify-content-start position-relative align-items-start">
                    <div className="mr-l">
                        <div className="row-auto-width mb-xs dkinput-header-section mt-r">
                            <DKLabel className="" text={`${c.name}${c.required ? ` *` : ''}`} />
                            {(canValidate && Utility.isEmpty(formValues.attachments) && c.required) && (
                                <DKTooltipWrapper
                                    content={c.tooltiptext}
                                    tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                                >
                                    <DKIcon
                                        src={ic_erro_info}
                                        className="ml-s ic-s ml-r mt-xs cursor-hand "

                                    />
                                </DKTooltipWrapper>
                            )}
                        </div>
                    </div>

                    <div className="row-auto-width dkinput-header-section ">
                        <div className="row" style={{ width: "auto" }}>
                            <DKButton className='p-s' icon={DKIcons.ic_attachment} onClick={() => {
                                setAttachmentPopup({
                                    showPopup: true
                                })
                            }} />
                        </div>

                    </div>
                    {formValues.attachments && <div className="">
                        {
                            formValues.attachments.map((file, index) => {
                                return (
                                    <div className="row mb-r">
                                        <DKButton icon={DKIcons.ic_download} className="bg-gray1 border-m" onClick={() => downloadDocument(file)} title={<DKLabel style={{ maxWidth: 135, minWidth: 135 }} className="ellipsis " text={getFileName(file)} />} />
                                        <DKIcon className="ic-s ml-s" src={DKIcons.ic_delete} onClick={() => deleteAttachment(index)} />
                                    </div>
                                )
                            })
                        }
                    </div>}
                </div>
            </div>
        )
    }
    const updateFormFieldConfigOptions = () => {
        const config = deepClone(formFieldConfig);
        const { users } = userList;
        
        let options = [];
        if(isAdmin || isManager) {
            options = users?.map((u) => {
                return {
                    id: u.userId,
                    name: `${u.firstName} ${u.lastName}`,
                    ...u
                }
            })
        } else {
            options = [ {
                iamUserId: TenantService.get(TENANT.IAM_USER_ID),
                id: TenantService.get(TENANT.USER_ID),
                name: `${TenantService.get(TENANT.FIRST_NAME)} ${TenantService.get(TENANT.LAST_NAME)}`
            }]
        }

        const hasAccess = PermissionUtils.hasAccess(MODULE.COMPENSATORY_OFF, [ACTION.CREATE, ACTION.EDIT]);
        const alteredFields = [{ columnCode: "employees", options: options, readOnly: !hasAccess }];
        EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
        return config;
    }
    const updateFormValues = (config) => {

        formValues['description'] = dataToUpdate['description'];
        formValues['workingHoliday'] = moment(dataToUpdate['workingHolidayFrom'], "YYYY-MM-DD");
        formValues['duration'] = dataToUpdate['duration'] === 1 ? "fullDay" : "halfDay";
        formValues['compOffId'] = dataToUpdate['compOffId'];
        formValues['attachments'] = dataToUpdate['attachments'];
        formValues['leaveDate'] = !Utility.isEmpty(dataToUpdate['from']) ? new Date(dataToUpdate['from']) : moment().toISOString()
    }

    const updateCompOffConfigOptions = (options, oldConfig, alterFields) => {
        const config = deepClone(oldConfig ? oldConfig : formFieldConfig);
        const columnToUpdate = { columnCode: "compOff", options: options };
        let alteredFields = [];
        if(alterFields) {
            alteredFields = [...alterFields,columnToUpdate]
        } else {
            alteredFields = [columnToUpdate]
        }
        EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
        return config;
    }
    const getFormFieldValues = (c) => {
        if (c.type == INPUT_TYPE.DROPDOWN) {
            return formValues[c.columnCode];
        } else {
            return formValues[c.columnCode]
        }
    }
    const getFormSection = () => {
        return (
            formFieldConfig.map((c, index) => {
                return (
                    <>
                        {c.type === INPUT_TYPE.DROPDOWN && c.uiVisible && (
                            <div
                                className="column p-h-m  mb-xxl padding-bottom-mobile"
                                key={c.columnCode}
                            >
                                <DKInput
                                    title={c.name}
                                    placeholder={c.name}
                                    value={getFormFieldValues(c)}
                                    className=''
                                    formatter={(c) => {
                                        /** How to render a selected option in case of object **/
                                        return c.name;
                                    }}
                                    displayKey={"name"}
                                    options={c.options}
                                    type={c.type}
                                    labelClassName=" text-align-left "
                                    onChange={(value) => {
                                        onChange(value, c);
                                    }}
                                    direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
                                    required={getFieldRequired(c) || c.required}
                                    readOnly={c.readOnly}
                                    onClick={() => { }}
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch: c.options && c.options.length > 6 ? true : false,
                                        searchableKey: "name",
                                        data: c.options,
                                        renderer: (index, obj) => {
                                            /*How to render dropdwon options from string of array*/
                                            return <DKLabel className="" text={obj.name} />;
                                        },
                                        onSelect: (index, value) => { },
                                        multiSelect: c.isMultiSelect,
                                    }}
                                    canValidate={c['canValid'] || canValidate}
                                    validator={(value) => {
                                        if (Utility.isEmpty(value) && value !== 0) {
                                            c['isValid'] = false;
                                            return false;
                                        } else if(c['hasError']) {
                                            c['isValid'] = false;
                                            return false;
                                        } else {
                                            c['isValid'] = true;
                                            return true;
                                        }
                                    }}
                                    errorMessage={c.errMsg}
                                />
                            </div>
                        )}
                        {(c.type === INPUT_TYPE.TEXT || c.type === INPUT_TYPE.DATE || c.type === INPUT_TYPE.NUMBER) && (
                            <div
                                className="column p-h-m mb-xxl padding-bottom-mobile"
                                key={c.columnCode}
                            >
                                <DKInput
                                    title={c.name}
                                    placeholder={c.name}
                                    value={formValues[c.columnCode]}
                                    className=''
                                    type={c.type}
                                    labelClassName=" text-align-left "
                                    onChange={(v) => {
                                        onChange(v, c);
                                    }}
                                    direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
                                    required={getFieldRequired(c) || c.required}
                                    readOnly={c.readOnly}
                                    onClick={() => { }}
                                    canValidate={canValidate || c['canValid']}
                                    validator={(value) => {
                                        if (Utility.isEmpty(value) && value !== 0 || (c.type === INPUT_TYPE.TEXT && Utility.isEmpty(value.trim()))) {
                                            c['isValid'] = false;
                                            return false;
                                        } else if (c.type === INPUT_TYPE.DATE) {
                                            return c['isValid']
                                        } else {
                                            c['isValid'] = true;
                                            return true;
                                        }
                                    }}
                                    errorMessage={c.errMsg}
                                />
                            </div>
                        )}
                        {c.type === "radio" && (
                            <div className={`column p-h-m mb-xxl padding-bottom-mobile ${c.columnCode}`}>
                                <div className="row row-responsive justify-content-start position-relative align-items-start">
                                    <div className="mr-l">
                                        <div className="row-auto-width mb-xs dkinput-header-section mt-r">
                                            <DKLabel className="" text={`${c.name}${getFieldRequired(c) ? ` *` : ''}`} />
                                            {!c.isValid && (
                                                <DKTooltipWrapper
                                                    content={c.tooltiptext}
                                                    tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                                                >
                                                    <DKIcon
                                                        src={ic_erro_info}
                                                        className="ml-s ic-s ml-r mt-xs cursor-hand "

                                                    />
                                                </DKTooltipWrapper>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row-auto-width mb-xs dkinput-header-section mt-r">
                                        {c.radioButtons && getRadioButtons(c, index)}
                                    </div>
                                </div>
                            </div>
                        )}
                        {c.type === "file" && attachmentField(c)}
                    </>
                )
            })
        )
    }

    return (
        <>
            <div className=" transparent-background">
                <div className="p-h-r pt-r pb-m popup-window popup-overflow" style={{ width: "100%" }}>
                    <div className="popup-wrapper parent-width parent-height">
                        {getHeader()}
                        <div className=" parent-width parent-width pt-xl">
                            {getFormSection()}
                        </div>
                    </div>
                </div>

            </div>
            {attachmentPopup?.showPopup && showUploadPopup()}
        </>
    )
}
export default ApplyCompOff;